import axios from 'axios';
import axiosRetry from 'axios-retry';

import { getHeaders } from '../helpers/serviceHelper';

import { apiUrls } from './urls';
import { API_KEY, RECAPTCHA_SITE_KEY } from '../env';

export default class DonationService {
    static makePayment(donation, idempotencyKey, verificationToken) {
        return axios.post(apiUrls.getDonationUrl(), donation, {
            headers: {
                'ApiKey': API_KEY,
                'Idempotency-Key': idempotencyKey,
                'Verification': verificationToken
            }
        })
    }

    static makePaymentV3(donation, idempotencyKey, verificationToken) {
        return axios.post(apiUrls.getDonationV3Url(), donation, {
            headers: {
                'ApiKey': API_KEY,
                'Idempotency-Key': idempotencyKey,
                'Verification': verificationToken
            }
        });
    }

    static getPaymentFee(orgPath, campaignPath, amount) {
        const requestAmount = amount || 0;
        return axios.get(apiUrls.getDonationCoverFeeUrl(orgPath, campaignPath, requestAmount),
            {
                headers: getHeaders()
            });
    }

    static makePaymentIntent(donation, idempotencyKey) {
        const instance = axios.create();
        
        instance.interceptors.request.use(async request => {
            request.headers.set('Verification', await this.getVerificationToken());
            return request;
        },
        error => Promise.reject(error));
        
        return instance.post(apiUrls.getDonationIntentUrl(), donation, {
            headers: {
                'ApiKey': API_KEY,
                'Idempotency-Key': idempotencyKey,
                'Verification': ""
            }
        });
    }

    static getVerificationToken() {
        const win = window;
        
        return new Promise((resolve, reject) => {
            if (RECAPTCHA_SITE_KEY && win.grecaptcha) {
                return win.grecaptcha.ready(_ => {
                    win.grecaptcha
                        .execute(RECAPTCHA_SITE_KEY, { action: "actionKey" })
                        .then(token => {
                            resolve(token);
                        })
                        .catch(error => {
                            reject(error);
                        });
                });
            }
        });
    }

    static getDonationIntentPublic(guid, idempotencyKey, verificationToken) {
        const instance = axios.create();
        
        instance.interceptors.request.use(async request => {
            request.headers.set('Verification', await this.getVerificationToken());
            return request;
        },
        error => Promise.reject(error));

        axiosRetry(instance, {
            retries: 10, // number of retries
            retryDelay: () => {
                return 500; // time interval between retries
            },
            retryCondition: error => {
                // if retry condition is not specified, by default idempotent requests are retried
                return error.response?.status === 400;
            },
        });
        
        return instance.get(apiUrls.getDonationIntentPublicUrl(guid), {
            headers: {
                'ApiKey': API_KEY,
                'Idempotency-Key': idempotencyKey,
                'Verification': verificationToken
            }
        });
    }
}